import { Component } from '@angular/core';
import { Globals } from '../../services/globals';
import { Child } from '../../models/child';
import { Packet } from '../../models/packet';
import { PacketService } from '../../services/packet.service';
import { ReportService } from '../../services/report.service';
import { LocalStorageService } from '../../services/local-storage.service';

@Component({
  selector: 'bb-report',
  templateUrl: './report.html',
  styleUrls: ['./report.scss'],
})

export class ReportPage {

  /**
   * 아동 정보 목록
   */
  private children: Child[];

  /**
   * Local storage
   */
  private $local: LocalStorageService = new LocalStorageService();

  /**
   * 회원번호
   */
  userNum: number;

  /**
   * 센터번호
   */
  centerNum: number;

  /**
   * 좌뇌 균형도
   */
  bleft: number = 0;

  /**
   * 우뇌 균형도
   */
  bright: number = 0;

  /**
   * 최근 검사 날짜
   */
  latestCheckupDate: string = '-';

  /**
   * 아동의 운동 진척도
   */
  exerciseProgress: number = 0;

  /**
   * 패킷 정보
   */
  packet: Packet = null;

  /**
   * 공유 정보.
   */
  g: Globals;

  constructor(
    private $packetService: PacketService,
    private $reportService: ReportService,
    g: Globals,
  ) {
    this.g = g;
    this.children = g.children;
    // 페이지 진입 시 뇌 균형도 획득
    this.viewEnter();
  }

  /**
   * 페이지 진입 시 뇌 균형도 획득
   */
  viewEnter() {
    this.bleft = 0;
    this.bright = 0;
    this.updateBrainBalance(this.g.child.num);
    this.updateLevel(this.g.child.num);
    this.updatePacket(this.g.child.num);
  }

  /**
   * title-bar로부터 아동 변경 감지하면 출력 정보 갱신
   * @param {number} bmiNum 변경된 아동 식볇 번호
   */
  onChildChanged(bmiNum: number) {
    // 자동 로그인을 위해 식별번호 저장
    this.$local.setChildNum(bmiNum.toString());
    this.g.setChildByNum(bmiNum);
    this.viewEnter();
  }

  /**
   * 서버로부터 뇌균형 정보를 획득하여 출력
   * @param {number} bmiNum 아동 식별번호
   */
  private updateBrainBalance(bmiNum: number) {
    this.$reportService.brainBalance(bmiNum).subscribe(
      (res) => {
        const left = Math.round(res.brainBalance[0]);
        const right = Math.round(res.brainBalance[1]);
        this.bleft = left || 0;
        this.bright = right || 0;
        this.latestCheckupDate = res.date || '';
      },
      () => {
        this.bleft = 0;
        this.bright = 0;
      });
  }

  /**
   * 서버로부터 레벨 진행도 (운동 진척도) 정보를 획득하여 출력
   * @param {number} bmiNum 아동 식별번호
   */
  private updateLevel(bmiNum: number) {
    this.$reportService.exerciseProgress(bmiNum).subscribe(
      (res) => {
        const progress = res && res.progress;
        this.exerciseProgress =
          progress !== undefined ? progress : 0;
      },
      () => {
        this.exerciseProgress = 0;
      });
  }

  /**
   * 서버로부터 패킷 정보를 획득하여 출력
   * @param {number} bmiNum 아동 식별번호
   */
  private updatePacket(bmiNum: number) {
    this.$packetService.packet(bmiNum).subscribe(
      (res) => {
        const data = res && res.data;
        if (data) {
          this.packet = new Packet(data);
        }
      },
      () => {
        this.packet = null;
      });
  }
}
